class Tabs {
    constructor() {
        this.init();
    }

    init() {
        const tabs = document.querySelectorAll('.tabWidget');
        const isEditMode = document.querySelectorAll('.sfPageEditor').length > 0;

        tabs.forEach(tab => {
            tab.classList.add('tabWrapper');
            var tabsCount = 0;
            var tabWrapperUL = tab.querySelector('ul.tabs');
            var tabContent = tab.querySelector('.tabContent')

            //generate desktop tabs
            tab.querySelectorAll('.tabHeaderText .sfContentBlock').forEach(el => {
                var liElement = document.createElement('li');
                liElement.innerHTML = el.innerHTML;
                tabWrapperUL.appendChild(liElement);
                tabsCount++;
            });
            tab.querySelectorAll('.tabHeaderText .ui-content-block').forEach(el => {
                var liElement = document.createElement('li');
                liElement.innerHTML = el.innerHTML;
                tabWrapperUL.appendChild(liElement);
                tabsCount++;
            });

            if (!isEditMode) {
                tab.querySelectorAll('.tabHeaderWrapper').forEach(el => {
                    el.classList.add('desktopHidden');
                });
            }

            //show first tab on desktop on init
            tab.querySelector('.singleTabWrapper').classList.add('visible');
            tabWrapperUL.querySelector('li').classList.add('active');
            tab.querySelector('.tabHeaderWrapper').classList.add('active');

            if (DeviceHelper.isMobilebrowser()) {
                tab.querySelector('.singleTabWrapper').classList.remove('visible');
                tabWrapperUL.querySelector('li').classList.remove('active');
                tab.querySelector('.tabHeaderWrapper').classList.remove('active');
            }

            //desktop tab click function
            var tabWrapperLi = tabWrapperUL.querySelectorAll('li');
            tabWrapperLi.forEach(tabLi => {
                tabLi.addEventListener('click', (ev) => {
                    tabWrapperUL.querySelector('.active').classList.remove('active');
                    let el = ev.target.tagName === 'LI' ? ev.target : ev.target.closest('li');
                    let index = Array.prototype.slice.call(tabWrapperUL.children).indexOf(el)
                    el.classList.add('active');
                    tab.querySelector('.singleTabWrapper.visible').classList.remove('visible');
                    tab.querySelectorAll('.singleTabWrapper')[index].classList.add('visible');
                    tab.querySelector('.tabHeaderWrapper.active').classList.remove('active')
                    tab.querySelectorAll('.tabHeaderWrapper')[index].classList.add('active');
                });
            });

            if (!isEditMode) {
                //mobile accordeon click
                var accordionWrapperLi = tabContent.querySelectorAll('.tabHeaderText');
                accordionWrapperLi.forEach(accordion => {
                    accordion.addEventListener('click', (ev) => {
                        let el = ev.target.closest(".singleTabWrapper");
                        let currentActive = el.querySelector('.tabHeaderWrapper');
                        if (currentActive.classList.contains('active')) {
                            currentActive.classList.remove('active');
                            currentActive.parentElement.classList.remove('visible');
                        }
                        else {
                            currentActive.classList.add('active');
                            currentActive.parentElement.classList.add('visible');
                        }
                    });
                });
            }
        });

        if (isEditMode) {
            var contentSwitcher = document.querySelector('.sfContentSwitcher');
            if (contentSwitcher) {
                contentSwitcher.addEventListener('click', function (event) {
                    var wrappers = document.querySelectorAll('.singleTabWrapper').forEach(singleTabWrapper => {
                        if (!singleTabWrapper.querySelector('.tabHeaderText .sfContentBlock')
                            && !singleTabWrapper.querySelector('.tabHeaderText .ui-content-block')) {
                            if (!singleTabWrapper.classList.contains('visible')) {
                                singleTabWrapper.classList.add('visible');
                            }
                        };
                    });
                });
            }
        }
    }
}

export default Tabs;